import { render, staticRenderFns } from "./FindMarketplaceLogo.vue?vue&type=template&id=a588804e&"
import script from "./FindMarketplaceLogo.vue?vue&type=script&lang=js&"
export * from "./FindMarketplaceLogo.vue?vue&type=script&lang=js&"
import style0 from "./FindMarketplaceLogo.vue?vue&type=style&index=0&id=a588804e&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports